import { DEFAULT_ITEMS_COUNT_PER_REQUEST } from '@app/constants/limits';
import { fetchLookbooks } from '@app/services/lookbookRepository';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const LOOKBOOKS_LIST_QUERY_KEY = 'LOOKBOOKS_LIST_QUERY_KEY';
interface Props {
  page: number;
  limit?: number;
}
export const useLookbooksList = ({ page, limit = DEFAULT_ITEMS_COUNT_PER_REQUEST }: Props) => {
  const { t } = useTranslation(['lookbook']);

  return useQuery({
    meta: {
      errorDescription: t('lookbook:fetch_error.description'),
      errorMessage: t('lookbook:fetch_error.message'),
    },
    queryFn: async () => fetchLookbooks(page, limit),
    queryKey: [LOOKBOOKS_LIST_QUERY_KEY, { limit, page }],
  });
};
